import React, { useState } from 'react'
import Loaderd from '../sample/loader1';
import { ReactInternetSpeedMeter } from 'react-internet-meter'



const Loader = () => {
    const [wifiSpeed, setwifiSpeed] = useState("")
    return (
        <div>
            <br /><br /><br /> <br /><br /><br /> <br /><br /><br />
            <ReactInternetSpeedMeter
                txtSubHeading="Internet is too slow"
                outputType="alert"
                customClassName={null}
                txtMainHeading="Opps..."
                pingInterval="1000" // sec
                thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte"
                threshold={100}
                callbackFunctionOnNetworkDown={(speed) => console.log(`Internet speed    down ${speed}`)}
                callbackFunctionOnNetworkTest={(speed) => setwifiSpeed(speed)} />
            <Loaderd
                wifiSpeed={wifiSpeed} />
        </div>
    )
}

export default Loader;